// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"G4-z"};